import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
    const location = useLocation();

    // Styles spécifiques selon les routes
    const footerStyles = {
        "/": "lg:fixed lg:bottom-0 lg:left-0 text-white bg-black",
        "/about": " lg:fixed lg:bottom-0 lg:left-0 text-white bg-black",
        "/team": "",
        "/culture": " lg:fixed lg:bottom-0 lg:left-0 text-white bg-black",
        "/work": "text-white bg-black",
        "/blog": "",
        "/contact": "hidden",
    };

    const currentStyle = footerStyles[location.pathname] || "bg-black text-white"; // Style par défaut

    return (
        <footer className={`flex lg:flex-row flex-col lg:gap-unset gap-2.5 justify-between lg:items-center w-full z-50 p-[1.25rem] ${currentStyle}`}>
            <div className="flex lg:flex-row flex-col lg:gap-10 gap-2.5 lg:items-center w-full">
                <div className="flex flex-col">
                    <Link to={"/"} className="font-light lg:text-[15px] text-[16px]">HOME</Link>

                    <a className="font-light lg:text-[15px] text-[16px]"
                        href="/" target="_blank" rel="noopener noreferrer">BEHANCE</a>
                </div>

                <div className="flex flex-col">
                    <a className="font-light lg:text-[15px] text-[16px]"
                        href="mailto:hello@wearebiam.com" target="_blank" rel="noopener noreferrer">HELLO@WEAREBIAM.COM</a>

                    <a className="font-light lg:text-[15px] text-[16px]"
                        href="tel:+22899711712" target="_blank" rel="noopener noreferrer">+228 99 71 17 12</a>
                </div>

                <div className="flex flex-col">
                    <p className="font-light lg:text-[15px] text-[16px]">A CREATIVE POWERHOUSE</p>
                    <a className="font-light lg:text-[15px] text-[16px]"
                        href="https://www.instagram.com/wearebiam/" target="_blank" rel="noopener noreferrer">INSTAGRAM</a>

                    <p className="font-light lg:text-[15px] text-[16px]"></p>
                </div>
            </div>

            <div className="flex lg:gap-10 lg:items-center lg:w-unset w-full lg:justify-end justify-end">
                <div className="flex flex-col text-right">
                    <p className="font-light lg:text-[15px] text-[16px]">2025 BEG</p>
                    <Link to={"/"} className="font-light lg:text-[15px] text-[16px] text-black">© COPYRIGHTS</Link>
                </div>
            </div>
        </footer>
    );
}

export default Footer;